var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"checkbox-group"},_vm._l((_vm.options),function(option){
var _obj;
return _c('div',{key:option.key,staticClass:"checkbox-group__item",class:( _obj = {
    'checkbox-group__item--selected': option.key == _vm.value
  }, _obj[option.status ? option.status : 'bg-primary'] = option.key == _vm.value, _obj ),on:{"click":function($event){return _vm.optionSelected(option.key)}}},[_vm._v("\n        "+_vm._s(option.value)+"\n    ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }